import { ProjectCandidatesList } from 'features/projects';

export const ProjectCandidates = () => {
	return <ProjectCandidatesList />;
};
